import React from "react";
import PropTypes from 'prop-types';
import Button from "UI/Button";

export default class SignupSuccess extends React.Component
{
    static propTypes = {
        form: PropTypes.object.isRequired
    };

    render()
    {
        return <figure className="shadow max-w-xl bg-white md:flex bg-slate-100 rounded-xl p-8 md:p-0 dark:bg-slate-800">
            <img
                className="w-24 h-24 md:w-48 md:h-auto md:rounded-none rounded-full mx-auto object-cover md:rounded-l-xl"
                src="/img/laura.jpeg" alt="" />
            <div className="pt-6 md:p-8 text-center md:text-left space-y-8">
                <blockquote className='relative'>
                    <svg
                        className="absolute top-0 left-0 transform -translate-x-3 -translate-y-2 h-8 w-8 text-indigo-800 opacity-10"
                        fill="currentColor"
                        viewBox="0 0 32 32"
                        aria-hidden="true"
                    >
                        <path
                            d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z"/>
                    </svg>
                    <p className="text-xl font-medium relative pt-2">
                        Hey <span className='capitalize'>{this.props.form.firstname}</span>, thanks for signing up!
                        Our flow isn't fully automated yet, but don't worry - I'll be in touch soon to finish setting up your account.
                    </p>
                </blockquote>
                <div>
                    <Button onClick={() => window.location = 'https://trypatchwork.com'}>Return to website</Button>
                </div>
                <figcaption className="font-medium">
                    <div className="text-indigo-800">
                        Laura Cairns
                    </div>
                    <div>
                        Co-founder, Patchwork
                    </div>
                </figcaption>
            </div>
        </figure>
    }
}
